

import { createApi } from '@reduxjs/toolkit/query/react'
import { backendBaseQuery } from '@shared/api'
import { ContactsListDTO } from '../model'

// Define a service using a base URL and expected endpoints
export const platformAdapterApi = createApi({
  reducerPath: 'platform-adapter-api',
  baseQuery: backendBaseQuery,
  tagTypes: ['PlatformAdapter'],
  endpoints: (build) => ({
    getContacts: build.query<ContactsListDTO, void>({
      query: () => ({
        url: `/platform-adapter/contacts`, 
        method: 'GET',
        keepUnusedDataFor: 15*60,
      })
    })
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { 
    useGetContactsQuery
} = platformAdapterApi